/**
 * This file defines the Program component, which serves as a container for displaying programming activity details and related issues.
 * The component renders the ProgrammingDetails component and the IssuesStudent component within tabs. Note that IssuesStudent is 
 * a placeholder component.
 */
import React from "react";
import ProgrammingDetails from "Screens1/Student/Course/Content/Programming/ComponentsNew/ProgrammingDetails/ProgrammingDetails.jsx";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import IssuesStudent from "Navigation/Course/Interactions/Issues/Student/issues.jsx";
import Countdown from "react-countdown";
import moment from "moment";
import countdownRenderer from "Components/Common/CountDownRenderer";

function Program({
  programId,
  activity_title,
  activity_description,
  AccessControlsProgActivity,
  ProgrammingActivityDetails,
  setAccessControlsProgActivity,
  studentData,
  isExam,
  provideAdditionalFiles,
  instructorAdditionalFiles,
  document,
  displayRunWithoutSubmitButton,
}) {
  const changeAccess = (update) => {
    setAccessControlsProgActivity(update);
  };

  return (
    <div>
      {/* Tabs for displaying programming activity details and related issues */}
      <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example">
        <Tab eventKey="profile" title="Programming details">
          <div style={{ overflowX: "hidden" }}>
            <ProgrammingDetails
              programId={programId}
              activity_title={activity_title}
              activity_description={activity_description}
              details={ProgrammingActivityDetails}
              changeAccess={changeAccess}
              access={AccessControlsProgActivity}
              provideAdditionalFiles={provideAdditionalFiles}
              instructorAdditionalFiles={instructorAdditionalFiles}
              document={document}
              displayRunWithoutSubmitButton={displayRunWithoutSubmitButton}
            />
          </div>
        </Tab>
        <Tab eventKey="issues" title="Issues">
          <IssuesStudent />
        </Tab>
        <Tab
          title={
            isExam &&
              studentData &&
              studentData.start_time &&
              !studentData.is_finished ? (
              <>
                {
                  (studentData?.end_time) ? <Countdown
                    date={
                      new Date(studentData.end_time).getTime()
                    }
                    renderer={countdownRenderer}
                  />
                    : <Countdown
                      date={
                        new Date(studentData.start_time).getTime() +
                        moment.duration(studentData.duration).asMilliseconds()
                      }
                      renderer={countdownRenderer}
                    />
                }
              </>
            ) : null
          }
        ></Tab>
      </Tabs>
    </div>
  );
}

export default Program;
